import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=3a0332ef&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=3a0332ef&prod&lang=scss&scoped=true"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=3a0332ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0332ef",
  null
  
)

export default component.exports